import { c as _c } from "react/compiler-runtime";
import { GOTHAM_DISPLAY } from '@cc-shopping/ui/theme';
import { Typography, type TypographyProps } from '@mui/material';
export const reviewsSectionTitleTypographyProps: TypographyProps<'h2'> = {
  marginY: {
    xs: 2,
    md: 4
  },
  marginBottom: {
    xs: 3,
    md: 2
  },
  fontWeight: 500,
  fontFamily: GOTHAM_DISPLAY,
  fontSize: {
    xs: '1.25rem',
    md: '1.5rem'
  }
};
export default function SectionTitle(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Typography component="h2" {...reviewsSectionTitleTypographyProps}>{children}</Typography>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}